import { tokenService } from '../services/tokenService';

const APPROVES_OWN_REQUESTS = ['ROLE_COMPANY_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_OPERATOR', 'ROLE_PLATFORM_ADMIN'];

export function displayEnrollmentMode<T extends string | undefined>(mode: T): T | 'self' {
    return mode === 'request' && tokenService.getRoles().some((role) => APPROVES_OWN_REQUESTS.includes(role)) ? 'self' : mode;
}
